import { render, staticRenderFns } from "./boardSettings.vue?vue&type=template&id=3e706dd4"
import script from "./boardSettings.vue?vue&type=script&lang=js"
export * from "./boardSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports